const bundles = {
	'ar-SA': {},
	'de-DE': {},
	'en-GB': {},
	'en-US': {
		'recognition.appLogo.ariaLabel': 'appLogo',
		'recognition.appCode.header': 'App Code',
		'recognition.appCode.extraLabel': 'Your company-specific app code',
		'recognition.appCode.signInLabel': 'Sign in below to RecognitionNow and start sending recognition directly through Outlook',
		'recognition.appCode.contactUs': 'Please contact your program administrator for assistance or email apps@biworldwide.com.',
		'recognition.appCode.inValidAppCode': 'Please enter a valid app code',
		'recognition.appCode.submitButton': 'Continue',
		'recognition.message.header': 'Your Message',
		'recognition.recognitionTextInput.label': 'Recognition text',
		'recognition.emojiButton.label': 'Add an emoji',
		'recognition.message.cardHeader': 'Image or eCard',
		'recognition.header.required': ' (Required)',
		'recognition.header.optional': ' (Optional)',
		'recognition.people.searchLabel': 'Who do you want to recognize?',
		'recognition.people.searchPlaceholder': 'Search people in your organization',
		'recognition.people.addTeamMembers': 'Click to add a person from your team',
		'recognition.program.header': 'Choose a program and add awards',
		'recognition.program.selectProgramLabel': 'Select a program',
		'recognition.program.availablePoints': 'Available to reward:',
		'recognition.program.expiresText': 'Expires in ${expireDays} days',
		'recognition.program.ineligibleSingle': 'recipient is ineligible for this program',
		'recognition.program.ineligibleMulti': 'recipients are ineligible for this program',
		'recognition.program.differentPoints': 'Allocate different points to each recipient',
		'recognition.program.behaviorHeader': 'Behavior',
		'recognition.program.behaviorSelectPlaceholder': 'Select a behavior',
		'recognition.program.pointsHeader': 'Add Points',
		'recognition.error.tooManyPoints': 'Cannot distribute more points than available',
		'recognition.program.rangeInstructions': 'Enter a value between ${min} and ${max}.',
		'recognition.program.rangePerPersonInstructions': 'Enter a value between ${min} and ${max} for each recipient.',
		'recognition.review.header': 'Review your recognition',
		'recognition.people.totalRecipients': '${recipientCount} RECIPIENTS',
		'recognition.people.totalRecipient': '1 RECIPIENT',
		'recognition.button.edit': 'Edit',
		'recognition.review.awardHeader': 'AWARDS',
		'recognition.review.personalizationHeader': 'YOUR MESSAGE',
		'recognition.visibility.public': 'Public',
		'recognition.visibility.publicText': 'Visible to everyone in your organization',
		'recognition.visibility.private': 'Private',
		'recognition.visibility.privateText': 'Visible to you, recipients, and their managers',
		'recognition.budget.awarded': '${points} ${mediaLabel} awarded',
		'recognition.budget.remaining': '${points} ${mediaLabel} remaining',
		'recognition.budget.available': '${points} ${mediaLabel} available',
		'recognition.button.saveRecipients': 'Save recipients',
		'recognition.button.saveProgram': 'Save program',
		'recognition.button.save': 'Save',
		'recognition.button.review': 'Preview',
		'recognition.button.send': 'Send',
		'recognition.breadcrumb.totalRecipients': '${recipientCount} RECIPIENTS',
		'recognition.breadcrumb.totalRecipient': '1 Recipient',
		'recognition.breadcrumb.program': 'Program',
		'recognition.breadcrumb.programLabel': 'PROGRAM',
		'recognition.button.cancel': 'Cancel',
		'recognition.error.uhOh': 'uh oh, something went wrong. Please try again.',
		'recognition.header.logout': 'Log Out',
		'recognition.header.balanceLabel': 'MY POINTS',
		'recognition.error.ineligible': 'Ineligible for selected proggram',
		'recognition.button.remove': 'Remove',
		'recognition.error.noBudget': 'Uh oh, your balance is zero. You appear to have used all your budget.',
		'recognition.error.outOfRange': 'The points you have entered are not in the required range for this program',
		'recognition.success.message': 'Your recognition was sent',
		'mediaLabel': 'Points',
		'recognition.message.placeholder': 'What would you like to say?',
		'recognition.allPointsInput.label': 'Points being awarded to all recipients',
		'recognition.individualPointsInput.label': 'Points for ${name}',

		'recognition.error.generic': 'Something went wrong, please correct the error - ${error}',
		'recognition.error.tooManyBudgets': 'You have too many budgets',
	},
	'es-ES': {},
	'es-MX': {},
	'fr-CA': {},
	'fr-FR': {},
	'id-ID': {},
	'it-IT': {},
	'ja-JP': {},
	'ko-KR': {},
	'nl-NL': {},
	'pl-PL': {},
	'pt-BR': {},
	'ru-RU': {},
	'th-TH': {},
	'tr-TR': {},
	'vi-VN': {},
	'zh-CN': {},
	'zh-TW': {}
};

export {
	bundles
};